import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Login from "../pages/Login";
import Empresas from "../pages/Empresas";
import Equipo from "../pages/Equipo";
import Encuesta from "../pages/Encuesta";
import PasswordRecovery from "../pages/PasswordRecovery.jsx";
import ResetPassword from "../pages/ResetPassword.jsx";
import PoliticaPrivacidad from "../pages/PoliticaPrivacidad.jsx";
import Database from "../pages/Database.jsx";
import Facturacion from "../pages/Facturacion.jsx";
import Loader from "../components/Loader";

function RoutesComponent({ shouldRedirect, isAuthResolved }) {
  if (!isAuthResolved) {
    return <Loader />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to={shouldRedirect ? "/empresas" : "/login"} replace />} />
        <Route path="/login" element={shouldRedirect ? <Navigate to="/empresas" replace /> : <Login />} />
        <Route path="/home" element={<Navigate to="/empresas" replace />} />
        <Route path="/empresas" element={<Empresas />} />
        <Route path="/equipo/:id" element={<Equipo />} />
        <Route path="/encuesta" element={<Encuesta />} /> 
        <Route path="/recover-password" element={<PasswordRecovery />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/datos" element={<Database />} />
        <Route path="/facturacion" element={<Facturacion />} />
        <Route path="*" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default RoutesComponent;
